module.exports = __webpack_public_path__ + "static/media/pen-paper-icon.ba088592.svg";